import { SportDataGatewayQueryInfo, EventsBySportIdRequest } from "sb-bff-integration";
import { MarketTypeRequest } from "sbtech-online-sportcontent-sportbook";
import { TimeRange } from "sbtech-sports-data-api-client";
/*tslint:disable:no-non-null-assertion */
export const queryBuilder = {
    eventStateMap: {
        [EventsBySportIdRequest.EventStateEnum.Live]: "isLive eq true",
        [EventsBySportIdRequest.EventStateEnum.PreLive]: "isLive eq false",
        [EventsBySportIdRequest.EventStateEnum.Mixed]: ""
    },
    buildQueryTopLeagues(queryParams) {
        const filters = [
            this.buildLiveFilter(queryParams.request),
            this.buildEventType(queryParams.request),
            this.buildSportsFilter(queryParams),
            this.buildEventTagsFilter(queryParams.request)
        ].filter(x => x !== "");
        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filters.join(" and ")}`, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        this.buildDateRangeFilter(queryParams.request, queryInfo);
        return queryInfo;
    },
    buildLiveFilter(request) {
        return this.eventStateMap[request.eventState || EventsBySportIdRequest.EventStateEnum.Mixed];
    },
    buildEventType(request) {
        return (request.eventTypes && request.eventTypes.length && `type in (${request.eventTypes.map(type => `'${type}'`).join(",")})`) || "";
    },
    buildSportsFilter(queryParams) {
        const sportIds = queryParams.request.ids;
        return sportIds.length ? `sportId in (${sportIds.map(x => `'${x}'`).join(",")})` : "";
    },
    buildEventTagsFilter(request) {
        return request.eventTags && request.eventTags.length
            ? `Tags/any(tag: tag in (${request.eventTags.map(tag => `'${tag}'`).join(",")}))` : "";
    },
    buildMarketsQuery(queryParams) {
        const marketsQueries = [];
        queryParams.request.marketTypeRequests.forEach(marketTypeRequest => {
            const marketTypes = `marketType/id in (${marketTypeRequest.marketTypeIds.map(m => `'${m}'`).join(",")})`;
            if (marketTypeRequest.sportIds.length) {
                const sportIds = `sportId in (${marketTypeRequest.sportIds.map(id => `'${id}'`).join(",")})`;
                marketsQueries.push(marketTypeRequest.statement === MarketTypeRequest.StatementEnum.Include
                    ? `(${marketTypes} and ${sportIds})`
                    : `(${marketTypes} and not(${sportIds}))`);
            }
            else {
                marketsQueries.push(`(${marketTypes})`);
            }
        });
        return `$filter=${marketsQueries.join(" or ")}`;
    },
    buildDateRangeFilter(request, queryInfo) {
        if (request.dateRange) {
            queryInfo.from = request.dateRange.from.toISOString();
            queryInfo.timeRange = TimeRange[request.dateRange.timeRange];
        }
    },
    buildQueryByRegionId(queryParams) {
        const filter = this.buildRegionIdFilter(queryParams.request.regionId);
        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filter}`, queryParams.messageHandler);
        return queryInfo;
    },
    buildRegionIdFilter(regionId) {
        return `regionId eq '${regionId}'`;
    },
    buildQueryByEventIds(queryParams) {
        const filter = this.buildEventIdsFilter(queryParams.request.ids);
        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filter}`, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        return queryInfo;
    },
    buildEventIdsFilter(eventIds) {
        return `id in (${eventIds.map(id => `'${id}'`).join(",")})`;
    },
    buildQueryByLeagueIds(queryParams) {
        const filter = this.buildLeagueIdsFilter(queryParams.request.ids);
        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filter}`, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        return queryInfo;
    },
    buildQueryByEventIdsOnly(queryParams, eventIds) {
        const filter = this.buildEventIdsFilter(eventIds);
        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filter}`, queryParams.messageHandler);
        return queryInfo;
    },
    buildLeagueIdsFilter(leagueIds) {
        return `leagueId in (${leagueIds.map(id => `'${id}'`).join(",")})`;
    }
};
//# sourceMappingURL=queryBuilder.js.map